// tslint:disable:max-line-length
import React from 'react';

const CallUsIcon: React.SFC<{}> = () => (
    <svg viewBox="0 0 100 100">
        <g>
            <path
                fill="currentColor"
                d="M60.8,87.8c-0.1-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3,0.1-0.4,0.1c-5.1,0.5-9.9-0.5-14.4-2.6c-6.7-3.2-12.7-7.3-18.4-11.9c-6.1-4.9-10.9-10.9-14.3-17.7c-2.2-4.4-4.1-8.9-5.5-13.5c-0.7-2.4-1.2-4.9-1.7-7.4c-0.3-1.9-0.4-3.8-0.6-5.7c-0.5-4.6,1.1-8.6,4.8-11.6c2.4-1.9,4.9-3.5,7.4-5.2c0.3-0.1,0.7-0.2,1-0.2c2-0.1,3.3,0.8,4.5,2.3c3.5,4.6,7.2,9.2,10.8,13.8c1.6,2,1.2,4.4-0.9,5.9c-2.2,1.5-4.4,3.1-6.6,4.6c-0.4,0.2-0.7,0.5-1.1,0.6c-0.8,0.2-0.8,0.6-0.6,1.2c0.9,4.2,3.1,8,5.6,11.5c3.9,5.4,8.5,10.1,14.3,13.7c0.8,0.5,1.6,0.9,2.2,1.3c2.6-1.9,5.1-3.7,7.6-5.4c2.4-1.7,4.8-1.4,6.5,0.9c3.7,4.7,7.4,9.4,11.1,14.2c1.5,2,1.2,4.3-0.8,5.8c-1.9,1.4-3.8,2.7-5.7,4c-0.3,0.2-0.7,0.4-1.1,0.6"
            />
            <path
                fill="currentColor"
                d="M77,34.5L86.2,24v10.5H77z M86.2,44.3h4.7v-6h4v-3.8h-4v-17h-4.2L71.1,35l0.9,3.3h14.1V44.3z M47.9,44.3h20.3v-4.1H54.8l5.8-4.6c5-3.8,7.3-6.1,7.3-10.3v-0.1c0-4.7-3.8-7.9-9.2-7.9c-5,0-7.7,2-10.3,5.5l3.5,2.6c2.1-2.7,3.9-4,6.4-4s4.5,1.5,4.5,4.1c0,2.4-1.4,4.1-5.2,7.2l-9.6,7.8V44.3z"
            />
        </g>
    </svg>
);
export { CallUsIcon };
